// jshint esversion: 8

export default {
  all: state => state.data,
  byId: state => id => state.data.find(item => item.id === id),
  byName: state => name => state.data.find(item => item.name === name),
};
